import React, {useEffect, useState} from "react";
import GenUtils from "../utils/GenUtils";
import {Constants} from "../constants/Constants";
import {NumberUtils} from "../utils/NumberUtils";
import DateUtils from "../utils/DateUtils";
import {StyledTableCell} from "../home/LiveStats";
import Games from "../constants/Games";
import Ticket from "../models/Ticket";
import Game from "../models/Game";
import {createStyles, Theme, Typography, withStyles} from "@material-ui/core";
import AppColors from "../colors/AppColors";
import TableRow from "@material-ui/core/TableRow";
import {cyan, grey, lightGreen, orange, red, teal} from "@material-ui/core/colors";

// noinspection JSUnusedLocalSymbols
const StyledTableRow = withStyles((theme: Theme) =>
    createStyles({
        root: {
            backgroundColor: AppColors.lightenOrDarken(AppColors.APP_BAR_BACKGROUND_COLOR, 30),
            cursor: 'pointer',
            '&:nth-of-type(odd)': {
                backgroundColor: AppColors.lightenOrDarken(AppColors.APP_BAR_BACKGROUND_COLOR, 40),
            },
            opacity: 0.1,
            transition: '5s'
        },
    }),
)(TableRow);

export default function SimpleTableRow(props: any) {

    const row = props.row;
    const position = props.position;
    const [opacity, setOpacity] = useState(.5);
    const defaultBackgroundColor = AppColors.lightenOrDarken(AppColors.APP_BAR_BACKGROUND_COLOR, 30);
    const cyanColor = cyan[900];
    const [firstRowBackgroundColor, setFirstRowBackgroundColor] = useState<any>(cyanColor);

    const getBackgroundColor = () => {
        return position % 2 !== 0 ? AppColors.lightenOrDarken(AppColors.APP_BAR_BACKGROUND_COLOR, 40) : defaultBackgroundColor
    }

    const handleClick = () => {
        GenUtils.moveToVerificationPage(row);
    }

    const gameSubType = (type: number) => {
        switch (type) {
            case 0:
                return Games.TWO_HITS;
            case 1:
                return Games.THREE_HITS;
            case 2:
                return Games.FOUR_HITS;
            case 3:
                return Games.FIVE_HITS;
            case 4:
                return Games.SIX_HITS;
            default:
                return Games.TWO_HITS;
        }
    }

    const ticketsString = (tickets: Ticket[]) => {
        let ticketString = "";
        for (let ticket of tickets) {
            ticketString = "[" + ticket.numbers!.toString() + "], " + ticketString;
        }
        return ticketString.replace(/,\s*$/, "");
    }

    useEffect(() => {
        if (opacity !== 1) {
            if (position === 0) {
                setFirstRowBackgroundColor(cyanColor);
                setTimeout(() => {
                    setFirstRowBackgroundColor(defaultBackgroundColor);
                }, 1000);
            }
            setOpacity(1);
        }
    });

    const VerifyView = (game: Game) => {
        return <Typography
            align={"center"}
            onClick={() => GenUtils.moveToVerificationPage(game)}
            style={{
                textDecoration: 'none',
                color: AppColors.CYAN,
                paddingTop: 5,
                cursor: 'pointer',
                paddingBottom: 5
            }}>VERIFY</Typography>
    }

    return <StyledTableRow
        onClick={handleClick}
        style={{
            opacity: opacity,
            backgroundColor: position === 0 ? firstRowBackgroundColor : getBackgroundColor()
        }}>
        <StyledTableCell align="center">
            {row.id.substring(row.id.length / 2)}
        </StyledTableCell>
        <StyledTableCell align="center">
            {row.playerUserName}
        </StyledTableCell>
        <StyledTableCell
            align="center">
            {row.gameType === 0 ? "FREE ROLL" : Constants.MULTIPLY_BTC_GAME}
        </StyledTableCell>
        {
            row.gameType === 1 &&
            <StyledTableCell
                align="center">
                {gameSubType(row.betType)}
            </StyledTableCell>
        }
        {
            row.gameType === 1 &&
            <StyledTableCell
                align="center" style={{
                color: grey[300]
            }}>
                {NumberUtils.toFixed(row.costPerTicket * row.tickets!.length)}
            </StyledTableCell>
        }
        {
            row.gameType === 1 &&
            <StyledTableCell
                align="center" style={{
                color: teal[100]
            }}>
                {ticketsString(row.tickets as any)}
            </StyledTableCell>
        }
        {
            row.gameType === 1 &&
            <StyledTableCell
                align="center" style={{
                color: orange[100]
            }}>
                {(row.winningNumbers.toString())}
            </StyledTableCell>
        }
        {
            row.gameType === 0 &&
            <StyledTableCell
                align="center">
                {row.luckyRoll}
            </StyledTableCell>
        }
        <StyledTableCell
            align="center" style={{
            color: lightGreen[200]
        }}>
            {row.wonAmount > 0 ? NumberUtils.toFixed(row.wonAmount) : ''}
        </StyledTableCell>
        {
            row.gameType === 1 &&
            <StyledTableCell
                align="center" style={{
                color: red[200]
            }}>
                {row.lostAmount > 0 ? NumberUtils.toFixed(row.lostAmount) : ''}
            </StyledTableCell>
        }
        <StyledTableCell
            align="center">
            {DateUtils.getElapsedTime(row.createdAt)}
        </StyledTableCell>
        <StyledTableCell align="center">
            {
                VerifyView(row)
            }
        </StyledTableCell>
    </StyledTableRow>
}